import React from 'react';

const PrivacyPolicy = () => (
  <div className="max-w-3xl mx-auto pb-12 px-4 pt-32 lg:pt-36">
    <h1 className="text-3xl font-bold mb-6 text-primary">Privacy Policy</h1>
    <p className="mb-4 text-text-secondary">
      Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our service.
    </p>
    <h2 className="text-xl font-semibold mt-8 mb-2">1. Information We Collect</h2>
    <ul className="list-disc ml-6 mb-4 text-text-secondary">
      <li>Account information (such as email, username)</li>
      <li>OAuth tokens for Spotify and YouTube (never your passwords)</li>
      <li>Usage data (e.g., playlists synced, app interactions)</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">2. How We Use Your Information</h2>
    <ul className="list-disc ml-6 mb-4 text-text-secondary">
      <li>To provide and improve our service</li>
      <li>To authenticate your accounts with Spotify and YouTube</li>
      <li>To communicate with you about updates or issues</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">3. Data Security</h2>
    <p className="mb-4 text-text-secondary">
      We use industry-standard security measures to protect your data. OAuth tokens are stored securely and never shared with third parties.
    </p>
    <h2 className="text-xl font-semibold mt-8 mb-2">4. Your Rights</h2>
    <ul className="list-disc ml-6 mb-4 text-text-secondary">
      <li>You can request deletion of your data at any time</li>
      <li>You can disconnect your accounts at any time</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">5. Changes to This Policy</h2>
    <p className="mb-4 text-text-secondary">
      We may update this Privacy Policy from time to time. We will notify you of any significant changes.
    </p>
    <h2 className="text-xl font-semibold mt-8 mb-2">6. Contact Us</h2>
    <p className="text-text-secondary">
      If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@playlistsync.com" className="text-primary underline">support@playlistsync.com</a>.
    </p>
  </div>
);

export default PrivacyPolicy; 